












import Vue from "vue"
import WideStaticNotice from "~/components/guideline/notice/WideStaticNotice.vue"

interface DataType {
  /**
   * サイドバーをfixさせる際に位置の計算で利用するパラメーター
   */
  alertText: String
  buttonText: String
}

export default Vue.extend({
  components: {
    WideStaticNotice,
  },
  data(): DataType {
    return {
      alertText:
        "スカウト、プロジェクトの掲載数&掲載条件無制限、ワーカー検索など\nすべての機能を無制限にご利用いただくには、有料プランへのご加入が必要です。\n下記ボタンからお問い合わせください。",
      buttonText: "有料プランについて問い合わせる",
    }
  },
  mounted() {
    this.$emit("showed-should-speal-said-plan-alert")
  },
  methods: {
    navigateToContactForm() {
      window.open(
        "https://crowdlinks.jp/client/form/contact/?from=paid_plan_alert",
        "_blank"
      )
    },
  },
})
